// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-b_bT","advertCardHeader__actions":"c-b_bU","advertCardHeader__bottomLabel":"c-b_bV"};